<template>
	<TopicTemplate 
		:name="name" 
		:topicImage="topicImage" 
		:title="title"
		:misc="misc"
		:description="getDescriptionText"
		:appointment="appointment"
		:summary="summary"
		:content="content"
		:result="result"
		:selected="selected">
	</TopicTemplate>
</template>
<script>

import AppointmentView from '../../mixin/appointment-view'
import TopicTemplate from './template/TopicTemplate'

export default {
	name: 'appointment_diagnosis_treatment_question',
	mixins: [ AppointmentView ],
	data() {
		return {
			name: 'diagnosis_treatment_question',
			topicImage: 'diagnosis.png',
			title: 'Diagnosis / Treatment',
			misc: true
		}
	},
	mounted() { 
	},
	computed: {
        getDescriptionText() {
            return `<strong>This section relates to topics you may want to discuss about diagnostic tests and procedures, as well as the various treatment options.</strong>`
        }
	},
	components: {
		TopicTemplate
	}
}
</script>

<style lang="scss" scoped>
</style>